// Definition of the user identity schema.
//
// This minimal reasonable user representation based on the
// SCIM 2.0 Schema https://datatracker.ietf.org/doc/html/rfc7643.

// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/user/v1/user.proto (package ai.h2o.user.v1, syntax proto3)
/* eslint-disable */

import { getNameParser } from "../../../../runtime";

/**
 * @generated from message ai.h2o.user.v1.User
 */
export type User = {
/**
 * Name of the User resource.
 *
 * For example: "users/<UUID>".
 * Don't confused with SCIM 2.0 'name' attribute that is not included in
 * this minimal representation and should be mapped to human_readable_name
 * field when included.
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * Name of the User that is displayed on the front-end.
 *
 * @generated from field: string display_name = 4;
 */
displayName?: string;
/**
 * Flag marking whether the User is active (true) or not (false).
 * This typically means whether User should by default appear in the query
 * result or whether it can authenticate.
 *
 * @generated from field: bool active = 5;
 */
active?: boolean;
/**
 * List of User's email addresses.
 *
 * @generated from field: repeated ai.h2o.user.v1.Email emails = 6;
 */
emails?: Email[];
/**
 * Unique user-friendly identifier of the User typically used for
 * the authentication.
 *
 * @generated from field: string login_principal = 7;
 */
loginPrincipal?: string;
}
;
export const userName = getNameParser<'user'>("users/{user}");
/**
 * Represents User's email.
 *
 * Exists as a dedicated message to allow extension as in SCIM 2.0 where email
 * can have type, etc.
 *
 * @generated from message ai.h2o.user.v1.Email
 */
export type Email = {
/**
 * @generated from field: string address = 2;
 */
address?: string;
}
;
